import ScrollMagic from "scrollmagic";
import counterAnimation from "../../js/utilities/counter";

import "./block-infographic.scss";

const blockInfographic = () => {
    const controller = new ScrollMagic.Controller();

    const allInfographicBlock = document.querySelectorAll(".block-infographic");
    if (!allInfographicBlock.length) return;

    allInfographicBlock.forEach((el) => {
        new ScrollMagic.Scene({
            triggerElement: el,
            offset: 0,
            triggerHook: 0.8,
            reverse: false,
        })
            .on("enter", () => {
                let innerNumbers = el.querySelectorAll(".value");
                if (innerNumbers.length) {
                    innerNumbers.forEach((elNum) => {
                        setTimeout(counterAnimation(elNum), 200);
                    });
                }
            })
            .setClassToggle(el, "animate")
            .addTo(controller);
    });
};

export default blockInfographic;
